import footerC from './footerC.vue'
export default footerC


// WEBPACK FOOTER //
// ./src/components/modal/FooterC/index.js